var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#9747FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16C13 15.534 13 15.301 13.076 15.117C13.1777 14.8725 13.3723 14.6783 13.617 14.577C13.801 14.5 14.034 14.5 14.5 14.5H17.5C17.966 14.5 18.199 14.5 18.383 14.576C18.6275 14.6777 18.8217 14.8723 18.923 15.117C19 15.301 19 15.534 19 16C19 16.466 19 16.699 18.924 16.883C18.8223 17.1275 18.6277 17.3217 18.383 17.423C18.199 17.5 17.966 17.5 17.5 17.5H14.5C14.034 17.5 13.801 17.5 13.617 17.424C13.3725 17.3223 13.1783 17.1277 13.077 16.883C13 16.699 13 16.466 13 16Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11V17C24.5 20.771 24.5 22.657 23.328 23.828C22.156 24.999 20.271 25 16.5 25H15.5M7.5 11V17C7.5 20.771 7.5 22.657 8.672 23.828C9.376 24.533 10.34 24.814 11.816 24.926M16 7H8C7.057 7 6.586 7 6.293 7.293C6 7.586 6 8.057 6 9C6 9.943 6 10.414 6.293 10.707C6.586 11 7.057 11 8 11H24C24.943 11 25.414 11 25.707 10.707C26 10.414 26 9.943 26 9C26 8.057 26 7.586 25.707 7.293C25.414 7 24.943 7 24 7H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveLearning);
export default __webpack_public_path__ + "static/media/archiveLearning.494e9f5290228bcfa393b4575ff9e30f.svg";
export { ForwardRef as ReactComponent };